import { useCallback } from "react";
import { useLanguage } from "../context/LanguageContext";
import {
  formatDateOnly as formatDateOnlyUtil,
  formatDateTime as formatDateTimeUtil,
} from "../utils/formatDate";

export function useFormatDate() {
  const { language } = useLanguage();

  const formatDateOnly = useCallback((value) => formatDateOnlyUtil(value, language), [language]);

  const formatDateTime = useCallback((value) => formatDateTimeUtil(value, language), [language]);

  return { formatDateOnly, formatDateTime, language };
}
